import { NotFoundPage } from '@pages/NotFoundPage';
import { useAuthContext } from '@providers/AuthProvider';
import { Initialization } from '@wrappers/Main/Initialization';
import { AuthenticatedNoOrgRoutes } from '@wrappers/routes/AuthenticatedNoOrgRoutes';
import { useLocation } from 'react-router-dom';
import { Routes } from './components/Routes';
import { getOrganizationSlugFromPathname } from './helpers/getOrganizationSlugFromPathname';

export const AuthenticatedRoutes = () => {
  const { me, organization, isOrgResolved } = useAuthContext();
  const { pathname } = useLocation();
  if (!me?.id) {
    return <Initialization />;
  }
  if (!isOrgResolved) {
    return <Initialization />;
  }
  const organizationSlug = getOrganizationSlugFromPathname(pathname);
  const isMemberOfRequestedOrganization =
    !organizationSlug ||
    (me.organizations ?? []).some((memberOrganization) => memberOrganization.slug === organizationSlug);
  if (!isMemberOfRequestedOrganization) {
    return <NotFoundPage />;
  }
  if (!organization) {
    return <AuthenticatedNoOrgRoutes />;
  }
  return <Routes />;
};
